import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { from } from 'rxjs';
import { PermissionDialog } from '@pt/pt-models';
import { PermissionDialogComponent } from '../dialogs/permission-dialog';

@Injectable({
  providedIn: 'root',
})
export class PermissionsDialogService {
  constructor(private modalService: NgbModal) {}

  runPermissionDialog = (permissionDialog: PermissionDialog) => {
    const modalRef = this.modalService.open(PermissionDialogComponent, {
      centered: true,
      backdrop: 'static',
      size: 'lg',
    });
    modalRef.componentInstance.init(permissionDialog);
    return from(modalRef.result);
  };
}
